import React, { memo, ReactNode, useState } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { width } from 'Utils/screen';
import { Tab } from 'Components/Tabs/Tab';
import classes from './rocketCallTabs.module.css';

interface Props {
  id?: string;
  className?: string;
  children?: ReactNode;
}

const createTabs = (activeTab: string, onTabClick: (e: any) => void) => (
  <>
    <Tab
      key="setup-tab"
      id="setup-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'setup-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketcallsetup"
      onClick={onTabClick}
    >
      <span>Set Up</span>
    </Tab>
    <Tab
      key="recordings-tab"
      id="recordings-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'recordings-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketcallrecordings"
      onClick={onTabClick}
    >
      <span>Recordings</span>
    </Tab>
  </>
);

/*
  In order to override bootstraps active class on tabs, there is a click event onTabClick, which will get the name of the tab that was clicked
  and then trigger a re-render.  Note in the createTabs method above, where the active class is added or not, based on which tab was clicked.
*/
function RocketCallTabs({ id = 'tabs', className, children }: Props) {
  // We want to set the initial active tab to the first tab in the incoming tabList
  const [activeTab, setActiveTab] = useState('setup-tab');

  const onTabClick = (e: any) => {
    // Occasionally, e.currentTarget is undefined.  Set the current activeTab if we run into this bug
    setActiveTab(e?.currentTarget?.id || activeTab);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className={classes.tabContainerWrapper}>
            <div className={classes.tabsContainer}>
              <ul
                className={`nav nav-tabs ${width < 576 ? 'flex-sm-column' : 'width'}   ${classes.tabs} ${
                  className || ''
                }`}
                id={id}
                role="tablist"
              >
                {createTabs(activeTab, onTabClick)}
              </ul>
            </div>
            <div
              className="tab-content w-100 h-100 d-inline-block"
              id="rocketcallTabContent"
              style={{ height: 'auto' }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

RocketCallTabs.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
};
const RocketCallTabsMemo = memo(RocketCallTabs, areEqual);
export { RocketCallTabsMemo as RocketCallTabs };
